<template>
  <div class="product">
    <div class="banner">
      <div class="title">智能内容分发</div>
      <div class="desc">
        <section>针对公域广告媒体及私域营销场景，支持内容进行端（内容中台）到端（用户触点）的</section>
        <section>极速分发，助力品牌实现全域增长</section>
      </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">立即体验
              <i class="el-icon-right"></i>
            </div>
          </router-link>
    </div>
    <div class="context">
      <div class="titleRow">
            <div class="title">高效的内容分发系统</div>
            <div class="desc">
                <section>针对全域营销场景，对各营销链路中的环节智能把控，保证</section>
                <section>品牌规范的基础上实现千人千面的分发效率</section>
            </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>营销场景全域覆盖</section>
            <section>打通公域广告+私域流量内容触点，全面覆盖主流互联网广告、新媒体平台、微信私域</section>
            <section>生态</section>
            <section class='title'>营销环节智能把控</section>
            <section>内容分发的品牌合规检测，严格的内容审批流程，保障品牌资产的统一性与规范性</section>
            <section class='title'>千人千面的分发效率</section>
            <section>通过AI工具箱智能批量生成内容，多渠道快速分发至各部门、渠道、门店、员工，全员</section>
            <section>可二次编辑生成个性化内容，进行千人千面的内容营销</section>
          </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">了解更多
              <i class="el-icon-right"></i>
            </div>
          </router-link>
        </div>
        <img class="img" src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/fission/fission1.png">
      </div>
      <div class="titleRow">
            <div class="title">全员私域营销</div>
            <div class="desc">
                <section>针对私域营销场景，通过ConTech创意云技术赋予全员内容生产能力，</section>
                <section>为企业提供全员私域营销解决方案</section>
            </div>
      </div>
      <div class="row">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/product/fission/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>全员任务派发</section>
            <section>营销中心借助内容中台统一发起营销任务，可根据角色、地域进行任务分配</section>
            <section class='title'>跨专业协同创作</section>
            <section>文案/平面/视频/H5智能生产和在线编辑，实现跨专业协作，一分钟实现私域内容的本</section>
            <section>地化与个性化</section>
            <section class='title'>品牌资产管理</section>
            <section>四级角色权限管理，智能把控内容创作及分发过程，确保品牌的合规统一</section>
          </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">了解更多
              <i class="el-icon-right"></i>
            </div>
          </router-link>
        </div>
      </div>
      <div class="titleRow">
            <div class="title">新媒体智能投放</div>
            <div class="desc">
                <section>自研智能kol投放系统kolstore，支持一键分发国内主流社交平台，</section>
                <section>实现用户的精准触达</section>
            </div>
      </div>
       <div class="row">
        <div class="introduce right">

          <div class="idesc">
            <div class="idesc">
                <section class='title'>全社交媒体平台资源储备</section>
                <section>kolstore覆盖国内主流社交媒体平台，拥有超过40w+KOL资源，涵盖微博、微信、抖</section>
                <section>音、快手、小红书、B 站等，为品牌提供一站式的投放服务</section>
                <section class='title'>程序化购买，网购一样的KOL投放体验</section>
                <section>程序化购买，实时充值下单，打通广告主传播需求与海量社交媒体资源</section>
           </div>
          </div>
          <router-link target="_blank"  to='/contact'>
            <div class="button">了解更多
              <i class="el-icon-right"></i>
            </div>
          </router-link>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/product/fission/3.png">
      </div>
    </div>
 <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/productBanner.vue'
export default {
  name: 'supply',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.product{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/product/fission/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
     background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 32px;
      }

    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
        padding-bottom: 78px;
      .drak{
        background: #F7F7F9;
      }
      .titleRow{
        text-align: center;
        width: 100%;
        padding-top: 80px;
        padding-bottom: 54px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3B3946;
            line-height: 45px;
        }
        .desc{
            margin-top: 16px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 22px;
        }
      }
      .row{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 20px;
            margin-bottom: 32px;
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 6px;
                margin-top: 24px;
                &:first-child{
                  margin-top: 0;
                }
                display: flex;
                align-items: center;
                  &::before{
                    content: '';
                    margin-right: 8px;
                    width: 12px;
                    height: 6px;
                    background: #5A2DF5;
                    border-radius: 1px;
                    display: block;
                }
            }
          }
        }
        .img{
          width: 595px;
        }

      }
    }
     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
</style>
